import "./App.css";
import Random from "./components/random/random/Random";

function App() {
  return (
    <div className="App">
      <Random />
    </div>
  );
}

export default App;
